module.exports = __webpack_public_path__ + "static/pipeline_overview-76635d7d8cac06d92f556f3f28c1e407.webp";